import { formatIsoDateTimeStringToLongMonthDisplayDate } from 'common/utils/LEGACY_timeHelpers';
import { FC } from 'react';

export const VisitorSessionHeader: FC<{
  startDate: string;
  itemCount: number;
  header: JSX.Element;
  tags: JSX.Element;
}> = ({ startDate, itemCount, header, tags }) => {
  return (
    <div className="grid grid-cols-12 w-full items-center">
      <div className="flex items-center p-2 col-span-3 text-left font-semibold text-sm">
        <i className="ra-icons-generic-calendar-1 text-primary-700 mr-2 flex text-lg"></i>
        {formatIsoDateTimeStringToLongMonthDisplayDate(startDate)}
      </div>
      <div className="flex justify-between col-span-7 lg:col-span-7 xl:col-span-8 text-left text-sm">
        <div className="flex items-center pl-2">{header}</div>

        <div className="flex flex-wrap gap-1 shrink p-2 text-left text-sm">
          {tags}
        </div>
      </div>
      {itemCount > 0 ? (
        <div className="col-span-2 xl:col-span-1 lg:col-span-2 pl-0 p-2 text-right text-sm">
          {itemCount === 1 ? `1 page` : `${itemCount} pages`}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
export const GeneralHeader: FC<{
  title: string;
}> = ({ title }) => {
  return (
    <h1 className="p-2 col-span-3 text-left font-semibold text-sm">{title}</h1>
  );
};
